import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {ChildrenComponents} from 'js/components/prop_types';
import Button from 'js/components/button';
import WorkflowPanel from 'js/components/workflow_panel';

import './index.scss';
import ApprovedBubbles from '../approved_bubbles';

export default class FeedbackPanel extends Component {
    static propTypes = {
        heading: PropTypes.string,
        subheading: PropTypes.string,
        onCancel: PropTypes.func,
        onSubmit: PropTypes.func,
        submitDisabled: PropTypes.bool,
        children: ChildrenComponents,
        sameSizeButtons: PropTypes.bool,
        previousButtonCopy: PropTypes.string,
        submitButtonCopy: PropTypes.string
    };

    static defaultProps = {
        heading: '',
        subheading: '',
        onCancel: R.identity,
        onSubmit: R.identity,
        submitDisabled: false,
        children: [],
        sameSizeButtons: true,
        previousButtonCopy: 'Prev',
        submitButtonCopy: 'Submit'
    };

    renderButtons() {
        const {
            onCancel,
            onSubmit,
            previousButtonCopy,
            submitButtonCopy
        } = this.props;
        return [
            <Button ghost bigtext notransform bold key="prev" className="feedback-panel__button" onClick={onCancel}>
                {previousButtonCopy}
            </Button>,
            <Button
                bigtext
                notransform
                bold
                key="submit"
                className="feedback-panel__button"
                onClick={onSubmit}
            >
                {submitButtonCopy}
            </Button>
        ];
    }

    render() {
        const {heading, subheading, sameSizeButtons} = this.props;
        return (
            <WorkflowPanel
                sameSizeButtons={sameSizeButtons}
                className="feedback-panel"
            >
                <ApprovedBubbles />
                <div className="feedback-panel__image" />
                <div className="feedback-panel__heading">{heading}</div>
                <div className="feedback-panel__subheading">{subheading}</div>
                {this.props.children}
                <div className="feedback-panel__button-container">
                    {this.renderButtons()}
                </div>
            </ WorkflowPanel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/feedback_panel/index.js